<h2 mat-dialog-title>{{ data.title }}</h2>
<mat-dialog-content>{{ data.message }}</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="onCancel()">{{ 'Cancel' | translate }}</button>
  <button mat-button color="primary" (click)="onConfirm()">{{ 'Confirm' | translate }}</button>
</mat-dialog-actions>
